module.exports = __webpack_public_path__ + "img/cert-logo.341e0d6f.jpg";